import { render, staticRenderFns } from "./customerListing.vue?vue&type=template&id=508e6de0&"
import script from "./customerListing.vue?vue&type=script&lang=js&"
export * from "./customerListing.vue?vue&type=script&lang=js&"
import style0 from "./customerListing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports